export const RemarkTranslations: Record<string, Record<string, string>> = {
    "zh": {
        "CAR": "航班延误",
        "CBH": "打开",
        "CCL": "关闭",
        "CDK": "打开",
        "CDL": "行李延误",
        "CFB": "第一件行李",
        "CKS": "打开",
        "CLB": "最后的行李",
        "COP": "打开",
        "DCL": "关闭",
        "DOP": "打开",
        "DRO": "重新打开",
        "FCF": "确认",
        "FCL": "航班取消",
        "FDL": "航班延误",
        "FDP": "航班起飞",
        "FDV": "改行",
        "FIN": "查询",
        "FLD": "航班登陆",
        "FRT": "重定时",
        "GBD": "航班登机",
        "GCH": "新登机口",
        "GCL": "关闭",
        "GFC": "最后呼叫",
        "GOP": "打开",
        "ICL": "关闭",
        "IOP": "打开",
        "KSK": "亭",
        "NTM": "新時間",
        "GLL": "呼叫",
        "FHD": "等待",
        "GCN": "登机口变更"
    },
    "ml": {
        "CDK": "BUKA",
        "CKS": "BUKA",
        "FCL": "DIBATALKAN",
        "FDL": "LEWAT",
        "FDP": "BERLEPAS",
        "FLD": "TIBA",
        "CCL": "TUTUP",
        "CFB": "B. PERTAMA",
        "CLB": "BEG AKHIR",
        "CDL": "BEG LEWAT",
        "COP": "BUKA",
        "GOP": "PINTU BUKA",
        "GCL": "PINTU TUTUP",
        "GBD": "SILA MASUK",
        "GFC": "PANGILLAN AKHIR",
        "GCH": "PINTU BARU",
        "DOP": "BUKA",
        "DRO": "BUKA",
        "DCL": "TUTUP",
        "DRC": "TUTUP",
        "IOP": "BUKA",
        "ICL": "TUTUP",
        "FCF": "DISAHKAN",
        "FIN": "PERTANYAAN",
        "FDV": "DST BARU",
        "FRT": "DITUNDA",
        "CAR": "LEWAT",
        "LCC": "DI LCCT",
        "ICC": "DI LCCT",
        "NXT": "BERIKUTNYA",
        "NXF": "BERIKUTNYA",
        "KSK": "GUNA KIOSK",
        "FRB": "PATAH BALIK",
        "NTM": "WAKTU BARU",
        "GTG": "SILA KE PINTU",
        "GSH": "PINTU PAPAR %s",
        "GLL": "PANGGILAN",
        "FHD": "MENUNGGU",
        "GCN": "PERTUKARAN PINTU"
    },
    "ar":
    {
        "CAR": "تأخرت",
        "CBH": "مفتوح",
        "CCL": "مغلق",
        "CDK": "مكتب مفتوح",
        "CDL": "تأخر الحقيبة",
        "CFB": "الحقيبة الأولى",
        "CKS": "مفتوح",
        "CLB": "الحقيبة الأخيرة",
        "COP": "افتح",
        "DCL": "مغلق",
        "DOP": "افتح",
        "DRO": "إعادة الفتح",
        "FCF": "تم التأكيد",
        "FCL": "تم إلغاء الرحلة",
        "FDL": "تأخر الرحلة",
        "FDP": "غادرت",
        "FDV": "حولت مسارها",
        "FIN": "استعلام",
        "FLD": "هبطت",
        "FRT": "تحديد وقت أخر",
        "GBD": "الصعود",
        "GCH": "بوابة جديدة",
        "GCL": "مغلق",
        "GFC": "الاتصال الاخير",
        "GOP": "افتح",
        "ICL": "مغلق",
        "IOP": "افتح",
        "KSK": "كشك",
        "NTM": "وقت جديد",
        "GLL": "نداء",
        "FHD": "انتظار",
        "GCN": "تغيير البوابة"
    }
}